import { Tag, type TagProps } from 'antd';
import type { CSSProperties } from 'react';
import { getBackgroundColor, getTextColor } from '../../shared-styles';

interface StyledTagProps extends Omit<TagProps, 'color'> {
  color?: string;
  $bgStrong?: boolean;
  $alignSelf?: CSSProperties['alignSelf'];
  $colorStrong?: boolean;
  $bgLight?: boolean;
  'tag-padding'?: CSSProperties['padding'];
  'tag-color'?: string;
}

export const StyledTag = ({
  color = 'default',
  $bgStrong,
  $alignSelf,
  $colorStrong,
  $bgLight,
  'tag-padding': tagPadding,
  'tag-color': tagColor,
  ...rest
}: StyledTagProps) => {
  const backgroundColor = getBackgroundColor(color, $bgLight, $bgStrong);
  const textColor = getTextColor(color, $colorStrong);

  return (
    <Tag
      {...rest}
      styles={{
        root: {
          flexShrink: 0,
          fontFamily: "'Noto Sans', sans-serif",
          fontSize: 14,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          padding: tagPadding ?? '2px',
          marginRight: 0,
          border: 'none',
          cursor: 'default',
          pointerEvents: 'none',
          alignSelf: $alignSelf ?? 'flex-start',
          backgroundColor,
          color: tagColor ?? textColor
        }
      }}
    />
  );
};
